module.exports = ":host {\n  background: #fff;\n  display: block; }\n\n.filters .form-control {\n  width: 100%;\n  min-width: 100px;\n  max-width: 200px; }\n\nul.columns {\n  padding: 0 20px; }\n\n.search {\n  max-width: 250px; }\n"


//////////////////
// WEBPACK FOOTER
// ./libs/chassis-core/src/app/datatables/components/datatable-layout/datatable-layout.component.scss
// module id = ./libs/chassis-core/src/app/datatables/components/datatable-layout/datatable-layout.component.scss
// module chunks = main